export default "/images/vendor/flag-icons/flags/4x3/ve.svg?8654417d0313322c0ee93b0de476124d";